import TextGradient from "../gradient/gradient-text";

const PrivacyPolicySectionHeader = () => {
  return (
    <div className="flex flex-col items-center gap-y-3 text-center md:max-w-[960px]">
      <span className="text-base-dark label-md">Last updated: January 24, 2022</span>
      <TextGradient>
        <span className="mobile-h3 xs:h4 md:h3">Privacy Policy</span>
      </TextGradient>
      <span className="pt-3 text-text-color-mid-em">
        This Privacy Policy describes Our policies and procedures on the
        collection, use and disclosure of Yourinformation when You use the
        Service and tells You about Your privacy rights and how the law protects
        You. 
        <br/>
        <br/>
        We use Your Personal data to provide and improve the Service. By
        using the Service,You agree to the collection and use of information in
        accordance with this Privacy Policy.
      </span>
    </div>
  );
};

export default PrivacyPolicySectionHeader;
